import { render, staticRenderFns } from "./SuppliersExpenses.vue?vue&type=template&id=40ad5b11&lang=pug"
import script from "./SuppliersExpenses.vue?vue&type=script&lang=js"
export * from "./SuppliersExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports